module.exports = __webpack_public_path__ + "img/p2.b02f5432.png";